import React from 'react'
import styled from '@emotion/styled'
import MobilityIcon from '../../icons/e-mobility.svg'
import LuceGasIcon from '../../icons/category-luce-gas.svg'
import FotovoltaicoIcon from '../../icons/category-fotovoltaico.svg'
import UltimeTeamIcon from '../../icons/category-ultime.svg'
import {Colors} from '../../styles/colors'
import {Typography} from '../../styles/typography'
import {CATEGORY_ENUM, categories} from '../../utils/blog/const'
import energyImg from '../../images/category-luce-gas.webp'
import eMobilityImg from '../../images/category-e-mobility.webp'
import solarImg from '../../images/category-solar.png'
import teamImg from '../../images/category-team.webp'
import {LENSES_MAP} from "./Lens";

export const CATEGORY_SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  largeplus:'largeplus',
  xlarge: 'xlarge',
}
export const CATEGORIES_MAP = {
  [CATEGORY_ENUM.LUCE_GAS]: {
    ...categories[CATEGORY_ENUM.LUCE_GAS],
    label: 'Luce & Gas',
    Icon: LuceGasIcon,
    alt: 'Luce e Gas',
    image: energyImg,
    description: 'Informazioni e approfondimenti su bollette, incentivi e sostenibilità'
  },
  [CATEGORY_ENUM.MOBILITA_ELETTRICA]: {
    ...categories[CATEGORY_ENUM.MOBILITA_ELETTRICA],
    label: 'Mobilità elettrica',
    Icon: MobilityIcon,
    alt: 'Mobilità elettrica',
    image: eMobilityImg,
    description: 'Guide e notizie per chi valuta l\'acquisto di un\'auto elettrica e per gli appassionati di e-mobility'
  },
  [CATEGORY_ENUM.FOTOVOLTAICO]: {
    ...categories[CATEGORY_ENUM.FOTOVOLTAICO],
    label: 'Fotovoltaico',
    Icon: FotovoltaicoIcon,
    alt: 'Fotovoltaico',
    image: solarImg,
    description: 'Guide e notizie dedicate a chi vuole acquistare un impianto fotovoltaico, ma anche a chi già usufruisce dell\'energia solare'
  },
  [CATEGORY_ENUM.ULTIME_TEAM]: {
    ...categories[CATEGORY_ENUM.ULTIME_TEAM],
    label: 'Ultime dal team',
    Icon: UltimeTeamIcon,
    alt: 'Ultime dal team',
    image: teamImg,
    description: 'Aggiornamenti su rilasci di nuove funzionalità, servizi e novità su Tate e sull\'app'
  }
}

const StyledCategory = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;

  .icon {
    width: 20px;
    height: 20px;
    margin-right: 6px;
    display: inline-block;
  }

  &[data-type='${CATEGORY_SIZES.small}'] {
    .icon {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }

  &[data-type='${CATEGORY_SIZES.large}'] {
    .icon {
      width: 28px;
      height: 28px;
      margin-right: 8px;
    }
  }

  &[data-type='${CATEGORY_SIZES.largeplus}'] {
    .icon {
      width: 38px;
      height: 38px;
      margin-right: 8px;
    }
  }

  &[data-type='${CATEGORY_SIZES.xlarge}'] {
    .icon {
      width: 48px;
      height: 48px;
      margin-right: 16px;
    }
  }
`

export const Category = ({category, size = CATEGORY_SIZES.medium, className}) => {
  if (!CATEGORIES_MAP[category]) {
    return null
  }

  const {label, alt, Icon} = CATEGORIES_MAP[category]
  const typography = {
    [CATEGORY_SIZES.medium]: Typography.label.label2_400,
    [CATEGORY_SIZES.small]: Typography.label.label4_400,
    [CATEGORY_SIZES.large]: Typography.heading.h5_700,
    [CATEGORY_SIZES.largeplus]: Typography.heading.h4_700,
    [CATEGORY_SIZES.xlarge]: Typography.heading.h2_700
  }[size]

  return <StyledCategory data-type={size} css={Colors.Color.eerieBlack600} className={className}>
    <Icon alt={alt} className={'icon'}/>
    <span css={typography}>{label}</span>
  </StyledCategory>
}


export const CategoryLens = ({category, size = CATEGORY_SIZES.medium, className, lens}) => {
  if (!CATEGORIES_MAP[category]) {
    return null
  }

  const typography = {
    [CATEGORY_SIZES.medium]: Typography.label.label2_400,
    [CATEGORY_SIZES.small]: Typography.label.label4_400,
    [CATEGORY_SIZES.large]: Typography.heading.h5_700
  }[size]

  const {label: categoryLabel} = CATEGORIES_MAP[category]
  const {title: lensLabel} = LENSES_MAP[lens]

  return <StyledCategory data-type={size} css={Colors.Color.eerieBlack600} className={className}>
    <span css={typography}>{categoryLabel} ~ {lensLabel}</span>
  </StyledCategory>
}
